import React from "react";
import { STATI_PREV } from "@/lib/preventivi";

export function StatoPreventivo({ stato }) {
  const s = STATI_PREV[stato] || STATI_PREV.bozza;
  return <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-medium border ${s.cls}`} data-testid={`prev-stato-${stato}`}>{s.label}</span>;
}
